import { TEXT_SIZING_PX } from './mixins/constants'

export interface AppTheme {
    colors: {
        brand: {
            primary: string
            dark: string
            alt: string
            muted: string
        }
        background: {
            app: string
            content: string
            control: string
            contentActive: string
            muted: string
            inverted: string
        }
        border: {
            primary: string
            secondary: string
            muted: string
        }
        text: {
            primary: string
            secondary: string
            muted: string
            inverted: string
        }
        link: {
            primary: string
        }
        input: {
            label: string
        }
        status: {
            success: string
            danger: string
            dangerMuted: string
            warning: string
            passive: string
            update: string
        }
        icon: {
            primary: string
            secondary: string
            muted: string
            inverted: string
            activity: string
            activityMuted: string
            danger: string
            dangerMuted: string
        }
        control: {
            inactive: string
            muted: string
            active: string
        }
    }
    fontFamily: {
        text: string
    }
    fontSizes: {
        sub: string
        label: string
        paragraph: string
        title: string
        header: string
    }
}
export type ThemedProps = { theme: AppTheme }

const NAVTRAC_BLUE = '#1E88E5'
const NAVTRAC_BLUE_DARK = '#1B2430'
const NAVTRAC_BLUE_MUTED = '#f1f8fd'
const WHITE = '#FFFFFF'
export const DARK_GRAY = '#AAAAAA'
export const GRAY = '#F3F4F5'
const CONTROL_DISABLED_GRAY = '#F5F5F5'
const BORDER_DISABLED_GRAY = '#D9D9D9'
const RED = '#FF0000'
const LIGHT_RED = '#ff9999'
export const SCALE_COLORS = ['#003a8c', '#00474f', '#22075e', '#780650']

export const theme: AppTheme = {
    colors: {
        brand: {
            primary: NAVTRAC_BLUE,
            dark: NAVTRAC_BLUE_DARK,
            alt: '#e57b1e',
            muted: NAVTRAC_BLUE_MUTED,
        },
        icon: {
            activity: NAVTRAC_BLUE,
            activityMuted: NAVTRAC_BLUE_MUTED,
            inverted: WHITE,
            muted: '#bfbfbf',
            secondary: '#8c8c8c',
            primary: '#595959',
            danger: RED,
            dangerMuted: LIGHT_RED,
        },
        background: {
            app: '#f4f7fa',
            control: WHITE,
            content: WHITE,
            contentActive: '#f1f8fd',
            muted: CONTROL_DISABLED_GRAY,
            inverted: NAVTRAC_BLUE_DARK,
        },
        border: {
            primary: '#D8D8D8',
            secondary: GRAY,
            muted: BORDER_DISABLED_GRAY,
        },
        text: {
            primary: '#141414',
            secondary: '#595959',
            muted: '#bfbfbf',
            inverted: WHITE,
        },
        link: {
            primary: NAVTRAC_BLUE,
        },
        input: {
            label: WHITE,
        },
        status: {
            success: '#009900',
            danger: RED,
            dangerMuted: LIGHT_RED,
            warning: '#F7C137',
            passive: GRAY,
            update: '#391085',
        },
        control: {
            inactive: DARK_GRAY,
            muted: CONTROL_DISABLED_GRAY,
            active: NAVTRAC_BLUE,
        },
    },
    fontFamily: {
        // NOTE: system font per https://css-tricks.com/snippets/css/system-font-stack/#method-1-system-fonts-at-the-element-level
        text:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    },
    fontSizes: {
        header: `${TEXT_SIZING_PX.header}px`,
        title: `${TEXT_SIZING_PX.title}px`,
        paragraph: `${TEXT_SIZING_PX.paragraph}px`,
        label: `${TEXT_SIZING_PX.label}px`,
        sub: `${TEXT_SIZING_PX.sub}px`,
    },
}
